export function buildExcelRowsFromObjects(objectRows) {
    if (!objectRows || objectRows.length === 0) return [];

    const headers = Object.keys(objectRows[0]);
    const headerRow = headers.map((header) => ({ value: header, fontWeight: 'bold' }));
    const dataRows = objectRows.map((row) =>
        headers.map((header) => ({ value: String(row[header] ?? ''), type: String }))
    );

    return [headerRow, ...dataRows];
}

export function buildExcelTitleRow(title, columnCount) {
    if (!title || !columnCount) return [];

    return [[
        { value: title, fontWeight: 'bold', fontSize: 14, columnSpan: columnCount },
        ...Array(columnCount - 1).fill(null),
    ]];
}

export function withExcelTitleRow(title, rows) {
    if (!title || !rows || rows.length === 0) return rows;

    const columnCount = rows[0].length;
    return [...buildExcelTitleRow(title, columnCount), ...rows];
}

export function buildObjectiveTitle(fromObjective) {
    if (!fromObjective) return '';

    const { nombre, nombre_servicio_unificado } = fromObjective;
    return nombre_servicio_unificado ? `${nombre} (${nombre_servicio_unificado})` : nombre;
}
